import { RangePicker } from "@/analytics/components/range-picker";
import { SampleChip } from "@/analytics/components/sample-chip";
import type { RangeDays } from "@/analytics/range";

/**
 * Home's own controls, at the start of the page bar above the numbers they scope: the range (7, 28
 * or 90 days, kept in the URL by the caller) and, when any figure below is sample data, the
 * "Sample data" chip beside it.
 */
export function HomeToolbar({ days, onRange, sample }: { days: RangeDays; onRange: (days: RangeDays) => void; sample: boolean }) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
      <RangePicker value={days} onChange={onRange} inline />
      <SampleChip shown={sample} />
    </div>
  );
}
